/* tslint:disable */
/* eslint-disable */
/**
 * Intee
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategorySubcategoryModel
 */
export interface CategorySubcategoryModel {
    /**
     * 
     * @type {string}
     * @memberof CategorySubcategoryModel
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategorySubcategoryModel
     */
    slug?: string | null;
}

export function CategorySubcategoryModelFromJSON(json: any): CategorySubcategoryModel {
    return CategorySubcategoryModelFromJSONTyped(json, false);
}

export function CategorySubcategoryModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategorySubcategoryModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'slug': !exists(json, 'slug') ? undefined : json['slug'],
    };
}

export function CategorySubcategoryModelToJSON(value?: CategorySubcategoryModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'slug': value.slug,
    };
}

